import TemperatureDataDownload from '../views/temperature/TemperatureDataDownload';
import DownloadTemperatureRequiresApp from '../views/temperature/DownloadTemperatureRequiresApp';
import { routeNames } from '../constants';

export default [
  {
    path: 'download-temperature',
    name: routeNames.temperature.download,
    component: TemperatureDataDownload,
    props: true,
    meta: {
      noTopNav: true,
    },
  },
  {
    path: 'download-temperature-requires-app',
    name: routeNames.temperature.downloadRequiresApp,
    component: DownloadTemperatureRequiresApp,
    props: true,
  },
];
